export const MEETINGS = {
  UPCOMING: 'Upcoming',
  PAST: 'Past'
};
